module.exports = __webpack_public_path__ + "img/专利转让件数图标.90211f2b.png";